const PathTranslations = {
    "/": "Home",
    "/app": "Dashboard",
    "/app/profile/": "Profile",

    "/auth/signUp": "Sign Up",
    "/auth/signUp.text": "Already Member ? ",
    "/auth/signUp.label": "Sign In",
    "/auth/signUp.link": "/auth/signIn",
    
    "/auth/signIn": "Sign In",
    "/auth/signIn.text": "Not member ? ",
    "/auth/signIn.label": "Sign Up",
    "/auth/signIn.link": "/auth/signUp",

    "/auth/passwordForgot": "Password Forgot",
    "/auth/passwordForgot.text": "Not member ? ",
    "/auth/passwordForgot.label": "Sign In",
    "/auth/passwordForgot.link": "/auth/signIn",

    "/app/tools/": "Tools",
    "/app/tools/exportSaved": "Export Saveds",
};
  
export default PathTranslations;
  